import { render, staticRenderFns } from "./radishMenu.vue?vue&type=template&id=410177e4&"
import script from "./radishMenu.vue?vue&type=script&lang=js&"
export * from "./radishMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports